export const mainDishesData = {
    5212: {
        id: '5212',
        orderNumber: 1,
        category: 'main',
        description: 'Тунец, спинка трески, тигровые креветки, фермерская курица и индейка.',
    },
    5213: {
        id: '5213',
        orderNumber: 2,
        category: 'main',
        description: 'Курица, индейка, свинина, фарш из говядины.',
    },
    5214: {
        id: '5214',
        orderNumber: 3,
        category: 'main',
        description: 'В качестве гарнира – сезонные овощи. Можно добавить крупы, чтобы в рационе было ещё больше клетчатки.',
    },
    5215: {
        id: '5215',
        orderNumber: 4,
        category: 'main',
        description: 'В качестве гарнира – сезонные овощи. Можно добавить крупы, чтобы в рационе было ещё больше клетчатки.',
    },
};

// OLD SET
// export const mealprepDishes = ['5212', '5213', '5214', '5215'];

// NEW SET
export const mealprepDishes = [
    // mealprep
    '5179', '5180', '5181', '5182', '5183',
    // dasha
    '5212', '5213', '5214', '5215', '5216',
    '5354', '5355', '5353', '5356', '5357',
    '5383', '5382', '5384', '5385', '5386',
    '5390', '5389', '5391', '5392', '5393',
    '5396', '5397', '5398', '5399', '5400',
    '5374', '5405', '5406', '5372', '5373',
    '5413', '5414', '5415', '5416', '5417',
];
